/* =============================================================
   StudentPreviewBanner.jsx — Admin preview mode indicator
   -------------------------------------------------------------
   Shown at the very top of the student portal when an IO manager
   is previewing the portal on behalf of a specific student.

   Features:
     - Displays the student's name so the admin knows who they are
       viewing as
     - "Exit Preview" button navigates back to the admin profile
       page (uses the ?from= URL param set by the profile page,
       falls back to /dashboard)
     - Hidden completely when isPreview is false (no DOM cost)

   Usage:
     <StudentPreviewBanner
       isPreview={isPreview}
       studentName={student?.name}
       exitUrl={exitUrl}
     />
   ============================================================= */

import { useNavigate } from 'react-router-dom';


export default function StudentPreviewBanner({ isPreview, studentName, exitUrl }) {
  const navigate = useNavigate();

  if (!isPreview) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-amber-400 text-amber-900">
      <div className="flex items-center justify-between px-6 py-2.5 max-w-screen-2xl mx-auto">

        <div className="flex items-center gap-2.5">
          <span className="material-symbols-outlined text-[18px]">preview</span>
          <p className="text-sm font-semibold">
            Preview mode
            {studentName && (
              <span className="font-normal ml-1.5">
                — viewing as <span className="font-semibold">{studentName}</span>
              </span>
            )}
          </p>
          <span className="text-xs bg-amber-500/40 px-2 py-0.5 rounded-full font-medium">
            Admin only
          </span>
        </div>

        <button
          onClick={() => navigate(exitUrl)}
          className="flex items-center gap-1.5 text-sm font-semibold px-3 py-1.5
                     bg-amber-900/10 hover:bg-amber-900/20 rounded-lg transition-colors"
        >
          <span className="material-symbols-outlined text-[16px]">close</span>
          Exit Preview
        </button>

      </div>
    </div>
  );
}
